import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart, LineElement, CategoryScale, LinearScale, PointElement, TimeScale, Tooltip } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import 'chartjs-adapter-date-fns';

// Enregistrer les éléments nécessaires dans Chart.js
Chart.register(LineElement, CategoryScale, LinearScale, PointElement, TimeScale, Tooltip, zoomPlugin);

const CustomGraph = ({ data, options }) => {
    return (
        <div className="graph-container">
            <Line data={data} options={options} />
        </div>
    );
};

export default CustomGraph;
